var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticStyle:{"background-color":"#f8f8f8"}},[_c('general-settings',{staticClass:"p-2",attrs:{"survey":_vm.survey}}),_c('hotspot-settings'),_c('lead-settings',{staticClass:"p-2"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }